import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { TranslocoPipe } from '@jsverse/transloco';
import { QuestionBankQuery } from '../../app/question-bank.query';

@Component({
  selector: 'dojo-question-bank-header',
  templateUrl: './question-bank-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoPipe],
})
export class QuestionBankHeaderComponent {
  constructor(private readonly questionBankQuery: QuestionBankQuery) {}

  readonly state = connectState({
    pagination: this.questionBankQuery.selectPagination(),
  });
}
